import { Component, OnInit } from '@angular/core';

import { LoginService } from './auth/login/login.service';
import { FooterComponent } from './footer/footer.component';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './header/header.component';

@Component({
    selector: 'clientapp-root',
    templateUrl: './clientapp.component.html',
    styleUrls: ['./clientapp.component.scss'],
    providers: [],
    imports: [HeaderComponent, RouterOutlet, FooterComponent]
})
export class ClientAppComponent {
  loadedFeature: any = 'login';

  constructor(
  	private lS: LoginService) {}

  ngOnInit() {
  }

  onNavigate(feature: Event) {
  	this.loadedFeature = feature;
  }

  isAuthenticated() {
    return this.lS.isAuthenticated();
  }
  
}